export default __webpack_public_path__ + "static/media/shoppinglist_female.66736fb1.png";